
import { Component, Vue, Prop} from 'vue-property-decorator';   
import { namespace } from "vuex-class";  

import Tooltip from "@/components/survey/Tooltip.vue";
import PageBase from "../PageBase.vue";

import { stepInfoType, stepResultInfoType } from "@/types/Application";

import "@/store/modules/application";
import { stepsAndPagesNumberInfoType } from '@/types/Application/StepsAndPages';
const applicationState = namespace("Application");

import { interpreterDetailsDataInfoType, requirementsAndConsiderationsSurveyDataInfoType } from '@/types/Application/TrialReadinessStatement';

@Component({
    components:{
        PageBase,
        Tooltip
    }
})
export default class RequirementsAndConsiderations extends Vue {
        
    @Prop({required: true})
    step!: stepInfoType;

    @applicationState.State
    public stPgNo!: stepsAndPagesNumberInfoType;    

    @applicationState.Action
    public UpdateStepResultData!: (newStepResultData: stepResultInfoType) => void
    
    reqInfo = {} as requirementsAndConsiderationsSurveyDataInfoType;
    currentStep =0;
    currentPage =0;   
    updated = 0;
    dataLoaded = false;

    state: any = {
        specialReqList: false,
        techSpecs: false,
        interpreterInfo: false,
        safetySpecs: false,
        trialSpecs: false,
        disabilitySpecs: false
    };

    mounted(){      
        this.dataLoaded = false;
        this.updated = 0;
        this.initStates();
        this.reloadPageInformation();
    }

    public initStates() {
        for (const key of Object.keys(this.state)) {
            this.state[key] = false;
        }
    }

    public updateSelection(){
        this.updated ++;
        this.checkFields();
    }

    public reloadPageInformation() {
        
        this.currentStep = this.$store.state.Application.currentStep;
        this.currentPage = this.$store.state.Application.steps[this.currentStep].currentPage;    

        this.reqInfo = {} as requirementsAndConsiderationsSurveyDataInfoType;
        this.reqInfo.specialReqList = [];
        this.reqInfo.interpreterInfo = {name: '', language: ''} as interpreterDetailsDataInfoType;
        this.reqInfo.techSpecs = '';
        this.reqInfo.safetySpecs = '';
        this.reqInfo.trialSpecs = '';
        this.reqInfo.disabilitySpecs = '';

        if (this.step.result?.requirementsAndConsiderationsSurvey?.data){
            const reqData = this.step.result.requirementsAndConsiderationsSurvey.data;
            this.reqInfo.specialReqList = reqData.specialReqList?reqData.specialReqList:[];            
            this.reqInfo.techSpecs = reqData.techSpecs?reqData.techSpecs:'';
            this.reqInfo.interpreterInfo = reqData.interpreterInfo?reqData.interpreterInfo:{};
            this.reqInfo.safetySpecs = reqData.safetySpecs?reqData.safetySpecs:'';
            this.reqInfo.trialSpecs = reqData.trialSpecs?reqData.trialSpecs:'';
            this.reqInfo.disabilitySpecs = reqData.disabilitySpecs?reqData.disabilitySpecs:'';
        }     
       
        const progress = this.checkFields(true)? 50 : 100; 
        Vue.filter('setSurveyProgress')(null, this.currentStep, this.currentPage, progress, false);     

        this.dataLoaded = true;
    }   

    public onPrev() {
        if (this.checkFields()){
            Vue.prototype.$UpdateGotoPrevStepPage();
        }        
    }

    public onNext() {        
        if (this.checkFields()){
            Vue.prototype.$UpdateGotoNextStepPage();   
        }    
    }  
    
    public checkFields(pageload?) {
        
        if(!pageload)
            this.state.specialReqList = this.reqInfo.specialReqList.length>0? false : true;       

        if (this.reqInfo.specialReqList.includes('technology')){
            this.state.techSpecs = this.reqInfo.techSpecs?false:true;
        } else {
            this.state.techSpecs = false;
        }

        if (this.reqInfo.specialReqList.includes('interpreter')){
            this.state.interpreterInfo = (this.reqInfo.interpreterInfo?.language && this.reqInfo.interpreterInfo?.name)?false:true;
        } else {
            this.state.interpreterInfo = false;
        }

        if (this.reqInfo.specialReqList.includes('safety')){
            this.state.safetySpecs = this.reqInfo.safetySpecs?false:true;
        } else {
            this.state.safetySpecs = false;
        }

        if (this.reqInfo.specialReqList.includes('accommodations')){
            this.state.trialSpecs = this.reqInfo.trialSpecs?false:true;
        } else {
            this.state.trialSpecs = false;
        }

        if (this.reqInfo.specialReqList.includes('disability')){
            this.state.disabilitySpecs = this.reqInfo.disabilitySpecs?false:true;
        } else {
            this.state.disabilitySpecs = false;
        }

        for (const key of Object.keys(this.state)) {
            if (this.state[key]) return false;
        }
        return true;
    }

    public getSelectedReqs(){
        let reqs = ''
        for(const req of this.reqInfo.specialReqList){
            if(req=='technology')           reqs+='Technology needs: '+ this.reqInfo.techSpecs+'\n';
            if(req=='interpreter')          reqs+='Interpreter for '+ this.reqInfo.interpreterInfo.name + ' in ' + this.reqInfo.interpreterInfo.language +'\n';
            if(req=='safety')               reqs+='Safety planning: '+ this.reqInfo.safetySpecs+'\n';
            if(req=='accommodations')       reqs+='Trial accommodations: '+ this.reqInfo.trialSpecs+'\n';
            if(req=='disability')           reqs+='Accommodations for disability: '+ this.reqInfo.disabilitySpecs+'\n';
        }
        return reqs;
    }   

    beforeDestroy() {
        const progress = this.checkFields()? 100 : 50;
        Vue.filter('setSurveyProgress')(null, this.currentStep, this.currentPage, progress, true);
        const questions = [{name:'Requirements and Considerations',title:'I need the following special requirements or considerations to support my trial:',value:this.getSelectedReqs()}]        
        this.UpdateStepResultData({step:this.step, data: {requirementsAndConsiderationsSurvey: {data: this.reqInfo, questions: questions, pageName:"Requirements and Considerations", currentStep:this.currentStep, currentPage:this.currentPage}}});
    }
}
